// filepath: src/utils/date.js

/** Format Date as ISO yyyy-mm-dd (UTC) */
export const iso = (d) => d.toISOString().slice(0, 10);

/** Epoch ms */
export const ts = (d) => d.getTime();

/** Parse "yyyy-mm-dd" (prefix ok) as UTC Date */
export const parseAPIDate = (str) => {
  const parts = String(str ?? "")
    .slice(0, 10)
    .split("-");
  if (parts.length !== 3) return new Date(NaN);
  const [y, m, d] = parts.map(Number);
  return new Date(Date.UTC(y, (m || 1) - 1, d || 1));
};

/** Days in the UTC month of given date */
export const getMonthDays = (d) =>
  new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth() + 1, 0)).getUTCDate();

/**
 * Month-To-Date bounds
 * lagDays: how many days behind API is (default 1 for SpotHero US)
 */
export const getMTD = (lagDays = 1) => {
  const now = new Date();
  const utcToday = new Date(
    Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate())
  );
  const yesterday = new Date(
    Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate() - 1)
  );
  const lagged = new Date(
    Date.UTC(
      now.getUTCFullYear(),
      now.getUTCMonth(),
      now.getUTCDate() - lagDays
    )
  );
  const first = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), 1));

  return {
    date_from: iso(first),
    date_to: iso(yesterday), // charts (T-1)
    date_to_lag: iso(lagged), // lagged endpoints
    utcToday,
    first,
    yesterday,
    lagged,
  };
};

/**
 * Year-To-Date bounds
 * lagDays: how many days behind API is (default 1 for SpotHero US)
 */
export const getYTD = (lagDays = 1) => {
  const now = new Date();
  const ytdFrom = new Date(Date.UTC(now.getUTCFullYear(), 0, 1));
  const lagged = new Date(
    Date.UTC(
      now.getUTCFullYear(),
      now.getUTCMonth(),
      now.getUTCDate() - lagDays
    )
  );
  const ytdTo = lagged < ytdFrom ? new Date(ytdFrom) : lagged;

  return { date_from: iso(ytdFrom), date_to: iso(ytdTo) };
};

/** Tick positions for current UTC month */
export const buildMonthTicks = (firstDate) => {
  const last = new Date(
    Date.UTC(firstDate.getUTCFullYear(), firstDate.getUTCMonth() + 1, 0)
  );
  const days = [1, 5, 10, 15, 20, 25, last.getUTCDate()];
  return days.map((d) =>
    ts(
      new Date(Date.UTC(firstDate.getUTCFullYear(), firstDate.getUTCMonth(), d))
    )
  );
};
